module.exports = __webpack_public_path__ + "641d28c4eca3692ea55c8872e4befc19.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-25.png
// module id = 3040
// module chunks = 0